import { render, staticRenderFns } from "./injectionMolding.vue?vue&type=template&id=6bb79493&scoped=true"
import script from "./injectionMolding.vue?vue&type=script&lang=js"
export * from "./injectionMolding.vue?vue&type=script&lang=js"
import style0 from "./injectionMolding.vue?vue&type=style&index=0&id=6bb79493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb79493",
  null
  
)

export default component.exports